import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import { ShieldCheck, Truck, ChartLineUp } from "@phosphor-icons/react";

const ICONS = { ShieldCheck, Truck, ChartLineUp };

export default function ValueProps() {
  const { t } = useLang();
  return (
    <section
      data-testid="values-section"
      className="bg-white dark:bg-zinc-950 py-24 md:py-32 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <Reveal className="lg:col-span-5">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.values.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.values.title}
            </h2>
          </Reveal>
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="h-px bg-slate-200 dark:bg-zinc-800" />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-slate-200 dark:bg-zinc-800 border border-slate-200 dark:border-zinc-800">
          {t.values.items.map((item, i) => {
            const Icon = ICONS[item.icon] || ShieldCheck;
            return (
              <Reveal
                key={i}
                delay={i * 120}
                className="bg-white dark:bg-zinc-950 p-8 md:p-10 group transition-colors duration-300 hover:bg-slate-50 dark:hover:bg-zinc-900"
                data-testid={`value-card-${i}`}
              >
                <div
                  className="w-14 h-14 flex items-center justify-center mb-6"
                  style={{
                    background: "rgba(0,82,255,0.08)",
                    color: "var(--icor-blue)",
                    borderRadius: 4,
                  }}
                >
                  <Icon size={28} weight="duotone" />
                </div>
                <div className="font-display text-2xl font-medium tracking-tight text-[var(--icor-navy)] dark:text-white mb-3">
                  {item.title}
                </div>
                <p className="text-slate-600 dark:text-zinc-400 leading-relaxed">{item.desc}</p>
                <div className="mt-6 h-px w-10 bg-slate-200 dark:bg-zinc-700 group-hover:w-20 group-hover:bg-[var(--icor-blue)] transition-all duration-500" />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
